import messages from './cmsVideoListing.json' with { type: 'json' };

export const cmsVideoListingFi: Readonly<typeof messages> = messages;
